// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M1.58018 21.7502L20.994 2.33594L22.4082 3.75013L21.1584 5H23V21H5.15873L2.99441 23.1644L1.58018 21.7502Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M11.4806 5H15.5102L1 19.5105V2.5H9.48063L11.4806 5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-folder-off-filled')
export default class FolderOffFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-off-filled',
    }
  }
}
